<template>
    <div    class="w-full flex flex-col">
        <h2>Single Select</h2>
        <div    class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
            <!-- (1) Single Select, First value selected -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[1]"
                    ></small-colored-check>

                    <p>
                        (1) This is a base line Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value is by default Clear. </span>

                <div    class="my-2"
                >
                    <select2    name="Select 1"
                                placeholder="Select a Value"
                                :options="options"
                    ></select2>
                </div>
            </div>

            <!-- (2) Single Select, value Selected -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[2]"
                    ></small-colored-check>

                    <p>
                        (2) This is a base line Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value: 'Beta' </span>

                <div    class="my-2"
                >
                    <select2    name="Select 2"
                                placeholder="Select a Value"
                                :options="options"
                                :value="selected"
                    ></select2>
                </div>
            </div>

            <!-- (3) Single Select, Value Selected, Allow Clear -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[3]"
                    ></small-colored-check>

                    <p>
                        (3) This is a base line Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value: 'Beta' </span>
                <span> Can Clear Selection: true </span>
                <span> Close On Select: false </span>

                <div    class="my-2"
                >
                    <select2    name="Select 4"
                                placeholder="Select a Value"
                                :options="options"
                                :value="selected"
                                :allow-clear="true"
                    ></select2>
                </div>
            </div>

            <!-- (4) Single Select, value Selected, Close On Select -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[4]"
                    ></small-colored-check>

                    <p>
                        (4) This is a base line Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value: 'Beta' </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: true </span>

                <div    class="my-2"
                >
                    <select2    name="Select 5"
                                placeholder="Select a Value"
                                :options="options"
                                :value="selected"
                                :close-on-select="true"
                    ></select2>
                </div>
            </div>

            <!-- (5) Single Select No Options, First Value Selected -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[5]"
                    ></small-colored-check>

                    <p>
                        (5) This is a base line Select2 w/ No Options.
                    </p>
                </div>
                <span> Value: null </span>
                <span> No Options </span>

                <div    class="my-2"
                >
                    <select2    name="Select Empty"
                                placeholder="Select a Value"
                                :options="ajaxEmptyOptions"
                    ></select2>
                </div>
            </div>

            <!-- (6) Single Select AJAX, empty selection -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[6]"
                    ></small-colored-check>

                    <p>
                        (6) This is a base line Select2 w/ Options loaded from AJAX.
                    </p>
                </div>
                <span> AJAX </span>
                <span> Value: null </span>

                <div    class="my-2"
                >
                    <select2    name="Select 6"
                                placeholder="Select a Value"
                                :options="ajaxOptions"
                    ></select2>
                </div>
            </div>

            <!-- (7) Single Select AJAX, value selected -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[7]"
                    ></small-colored-check>

                    <p>
                        (7) This is a base line Select2 w/ Options loaded from AJAX. and a value pre-selected
                    </p>
                </div>
                <span> AJAX </span>
                <span> Value: '[AJAX] Beta' </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: false </span>

                <div    class="my-2"
                >
                    <select2    name="Select 7"
                                placeholder="Select a Value"
                                :options="ajaxOptions"
                                v-model:value="ajaxSelectedStrings[0]"
                    ></select2>
                </div>
            </div>

            <!-- (8) Single Select, value Selected -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[8]"
                    ></small-colored-check>

                    <p>
                        (8) This is a base line Select2 w/ Options loaded from AJAX. and a value pre-selected
                    </p>
                </div>
                <span> AJAX </span>
                <span> Value: '[AJAX] Gamma' </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: false </span>

                <div    class=""
                >
                    <select2    name="Select 8"
                                placeholder="Select a Value"
                                :options="ajaxOptions"
                                :value="ajaxSelectedStrings[1]"
                    ></select2>
                </div>
            </div>

            <!-- (9) Single Select, value Selected, can clear selection -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[9]"
                    ></small-colored-check>

                    <p>
                        (9) This is a base line Select2 w/ Options loaded from AJAX.
                    </p>
                </div>
                <span> AJAX </span>
                <span> Value: '[AJAX] Beta' </span>
                <span> Can Clear Selection: true </span>
                <span> Close On Select: false </span>

                <div    class="my-2"
                >
                    <select2    name="Select 9"
                                placeholder="Select a Value"
                                :options="ajaxOptions"
                                :value="ajaxSelectedStrings[3]"
                                :allow-clear="true"
                    ></select2>
                </div>
            </div>

            <!-- (10) Single Select, value Selected, close on select -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[10]"
                    ></small-colored-check>

                    <p>
                        (10) This is a base line Select2 w/ Options loaded from AJAX.
                    </p>
                </div>
                <span> AJAX </span>
                <span> Value: '[AJAX] Gamma' </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: true </span>

                <div    class="my-2"
                >
                    <select2    name="Select 10"
                                placeholder="Select a Value"
                                :options="ajaxOptions"
                                :value="ajaxSelectedStrings[4]"
                                :close-on-select="true"
                    ></select2>
                </div>
            </div>
        </div>

        <h2>Multiple Select</h2>
        <div    class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
            <!-- (11) Multi Select, Empty -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[11]"
                    ></small-colored-check>

                    <p>
                        (11) This is a Multiple Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Select is Clear. </span>

                <div    class="my-2"
                >
                    <select2    name="Select 11"
                                placeholder="Select a Value"
                                :multiple="true"
                                :options="options"
                                v-model:value="multipleValues[0]"
                    ></select2>
                </div>
            </div>

            <!-- (12) Multi Select, value selected -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[12]"
                    ></small-colored-check>

                    <p>
                        (12) This is a Multiple Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value: [Alpha, Beta] </span>

                <div    class="my-2"
                >
                    <select2    name="Select 12"
                                placeholder="Select a Value"
                                :multiple="true"
                                :options="options"
                                v-model:value="multipleValues[1]"
                    ></select2>
                </div>
            </div>

            <!-- (13) Multi Select, value selected -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[13]"
                    ></small-colored-check>

                    <p>
                        (13) This is a Multiple Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value: [Alpha, Gamma] </span>
                <span> Can Clear Selection: true </span>

                <div    class="my-2"
                >
                    <select2    name="Select 13"
                                placeholder="Select a Value"
                                :multiple="true"
                                :allow-clear="true"
                                :options="options"
                                v-model:value="multipleValues[2]"
                    ></select2>
                </div>
            </div>

            <!-- (14) AJAX Multi Select, Cleared w/ null -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[14]"
                    ></small-colored-check>

                    <p>
                        (14) This is a Multiple Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> AJAX </span>
                <span> Value: null </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: false </span>

                <div    class="my-2"
                >
                    <select2    name="Select 14"
                                placeholder="Select a Value"
                                :options="ajaxMultipleOptions"
                                v-model:value="ajaxMultipleValues[0]"
                                :multiple="true"
                                :allow-clear="false"
                    ></select2>
                </div>
            </div>

            <!-- (15) AJAX Multi Select, Cleared w/ [] -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[15]"
                    ></small-colored-check>

                    <p>
                        (15) This is a Multiple Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> AJAX </span>
                <span> Value: null </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: false </span>

                <div    class="my-2"
                >
                    <select2    name="Select 15"
                                placeholder="Select a Value"
                                :options="ajaxMultipleOptions"
                                v-model:value="ajaxMultipleValues[1]"
                                :multiple="true"
                                :allow-clear="false"
                                :close-on-select="false"
                    ></select2>
                </div>
            </div>

            <!-- (16) AJAX Multi Select, Value Selected -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[16]"
                    ></small-colored-check>

                    <p>
                        (16) This is a Multiple Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> AJAX </span>
                <span> Value: ['[AJAX] Alpha', '[AJAX] Beta'] </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: false </span>

                <div    class="my-2"
                >
                    <select2    name="Select 16"
                                placeholder="Select a Value"
                                :options="ajaxMultipleOptions"
                                v-model:value="ajaxMultipleValues[2]"
                                :multiple="true"
                                :allow-clear="false"
                                :close-on-select="false"
                    ></select2>
                </div>
            </div>
        </div>

        <h2>Group Select</h2>
        <div    class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
            <!-- (17) Group Select, Empty -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[17]"
                    ></small-colored-check>

                    <p>
                        (17) This is a Group Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value: null </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: false </span>

                <div    class="my-2"
                >
                    <select2-group      name="Select 17"
                                        :options="groupOptions"
                                        v-model="groupSelections[0]"
                    ></select2-group>
                </div>
            </div>

            <!-- (18) Group Select, Value Selected -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[18]"
                    ></small-colored-check>

                    <p>
                        (18) This is a Group Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value: Rho </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: false </span>

                <div    class="my-2"
                >
                    <select2-group      name="Select 18"
                                        :options="groupOptions"
                                        v-model="groupSelections[1]"
                    ></select2-group>
                </div>
            </div>

            <!-- (19) Group Select, Value Selected, Allow Clear -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[19]"
                    ></small-colored-check>

                    <p>
                        (19) This is a Group Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value: Gamma </span>
                <span> Can Clear Selection: true </span>
                <span> Close On Select: false </span>

                <div    class="my-2"
                >
                    <select2-group      name="Select 19"
                                        :options="groupOptions"
                                        v-model="groupSelections[2]"
                                        :allow-clear="true"
                    ></select2-group>
                </div>
            </div>

            <!-- (20) Group Select, Value Selected, Allow Clear -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[20]"
                    ></small-colored-check>

                    <p>
                        (20) This is a Group Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value: a </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: true </span>

                <div    class="my-2"
                >
                    <select2-group      name="Select 20"
                                        :options="groupOptions"
                                        v-model="groupSelections[3]"
                                        :allow-clear="false"
                                        :close-on-select="true"
                    ></select2-group>
                </div>
            </div>

            <!-- (21) Group Select, Value Selected, Allow Clear -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[21]"
                    ></small-colored-check>

                    <p>
                        (21) This is a Group Select2 w/ Options loaded from the components Blade (Vue Properties).
                    </p>
                </div>
                <span> Value: b </span>
                <span> Can Clear Selection: true </span>
                <span> Close On Select: true </span>

                <div    class="my-2"
                >
                    <select2-group      name="Select 21"
                                        :options="groupOptions"
                                        v-model="groupSelections[4]"
                                        :allow-clear="true"
                                        :close-on-select="true"
                    ></select2-group>
                </div>
            </div>

            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    :togglable="true"
                                            v-model="testGood[20]"
                    ></small-colored-check>

                    <p>
                        (22) This is a Group Select2 w/ selectable groups
                    </p>
                </div>
                <span> Value: {{ groupSelections[5] }} </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: true </span>

                <div    class="my-2"
                >
                    <select2-group      name="Select 22"
                                        :options="groupOptions"
                                        v-model="groupSelections[5]"
                                        :selectable-groups="true"
                                        :multiple="true"
                                        :allow-clear="false"
                                        :close-on-select="false"
                    ></select2-group>
                </div>
            </div>
        </div>

        <h2>Select All</h2>
        <div    class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
            <!-- (22) Multi-Select All -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    v-model="testGood[22]"
                                            :togglable="true"
                    ></small-colored-check>

                    <p>
                        (22) This is a basic Multi-Select2 which can select all.
                    </p>
                </div>
                <span> Value: null </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: false </span>
                <span> Can Select All: true </span>

                <div    class="my-2"
                >
                    <select2      v-model="multipleValues[0]"
                                    :can-select-all="true"
                                    :multiple="true"
                                    :options="options"
                                    name="Select 22"
                    ></select2>
                </div>
            </div>

            <!-- (23) Multi-Select Cannot Select All -->
            <div    class="flex flex-col my-2 mx-4 py-1 px-2 border border-solid border-gray-900 rounded-md">
                <div    class="mb-2 flex items-center">
                    <small-colored-check    v-model="testGood[23]"
                                            :togglable="true"
                    ></small-colored-check>

                    <p>
                        (23) This is a basic Multi-Select2 which cannot select all.
                    </p>
                </div>
                <span> Value: null </span>
                <span> Can Clear Selection: false </span>
                <span> Close On Select: false </span>
                <span> Can Select All: false </span>

                <div    class="my-2"
                >
                    <select2      v-model="multipleValues[3]"
                                  :can-select-all="false"
                                  :multiple="true"
                                  :options="options"
                                  name="Select 22"
                    ></select2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';

import Select2 from '@/components/elements/select2'
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import Select2Group from "@/components/elements/select2-group";

export default {
    name: "Select2Test",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {Select2Group, SmallColoredCheck, Select2, },
    props: {
        options: Object,
        selected: String,
        groupOptions: Object,
    },
    data() {
        return {
            ajaxOptions: null,
            ajaxEmptyOptions: {},
            ajaxSelectedStrings: ['', '', '', '', ''],
            ajaxSelectedNull: null,

            multipleValues: [
                [],
                ['alpha', 'beta'],
                ['alpha', 'gamma'],
                [],
                [],
            ],

            ajaxMultipleOptions: null,
            ajaxMultipleValues: [[], [], [], [], []],

            groupSelections: [
                '',
                'rho',
                'gamma',
                'a',
                'b',
                'c',
            ],
            selections: [
                '',
            ],
            ajaxGroupOptions: null,
            ajaxGroupSelections: null,

            errors: [],
            testGood: [],
        }
    },
    created() {
        
    },
    mounted() {
        if (this.testGood.length === 0) {
            for (let count = 0; count < 100; count++) {
                this.testGood.push(false)
            }
        }
        this.loadData()
    },
    methods: {
        loadData() {
            axios.get('/scripts/ui-tests/select2-api', {

            }).then(response => {
                let data = response.data
                this.ajaxOptions = data.options
                this.ajaxMultipleOptions = data.options
                this.ajaxMultipleValues = data.ajaxMultipleValues

                for (let index = 0; index < this.ajaxSelectedStrings.length; index++) {
                    this.ajaxSelectedStrings[index] = data.values[index]
                }
            }).catch(error => {
                this.errors.push({
                    brief: 'Error Retrieving data from scripts/ui-tests/select2-api',
                    full: error,
                })
            }).then(() => {

            })
        },
    },
    computed: {
        
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>